define.alias("ember-math-helpers/helpers/max", "preview-grid/helpers/max");